import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

import { getNextTwelveMonths } from 'app/utils'


export default function SelectStaticMonth({ ...props }) {

    const myProps = {
        options: getNextTwelveMonths(),
        placeholder: i18n.t('common:filters.allSources'),
        isClearable: false, 
        isMulti: false,
        firstSelect: true,
        icon: { icon: 'calendar' },
        ...props
    }

    return <SelectSeeker {...myProps} />
}